module.exports = __webpack_public_path__ + "static/assets/2f645aa99f590cddb7445785f96b1710.svg";